var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"money-tag",style:(_vm.color ? ("color: " + _vm.color) : '')},[_c('i',{staticClass:"tag__icon"},[_vm._v("¥")]),_c('span',{staticClass:"tag__text"},[_vm._v(_vm._s(_vm.amount))])])}
var staticRenderFns = []

export { render, staticRenderFns }